module.exports = __webpack_public_path__ + "img/fashion_100.efe8449e.jpg";